import { memo, useState, useEffect } from 'react'
import { message, Table } from 'antd'
import dayjs from 'dayjs'
import queryString from 'query-string'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

import { MIN_SCREEN_WIDTH, threeMonth } from '@/constants'
import TxRecordApi from '@/services/apis/history/TxRecords'
import styles from './index.module.scss'
import { useTranslation } from '@/services/i18n'
import { AddressItemModel, TxConditionModel, TxRecordsModel } from '@/services/apis/history/model'
import { PageModel } from '@/services/apis/BaseModel'
import CoinImgName from '../../components/coinimgName'
import { TxStatusEnum, TX_ACCOUNT_TYPE_ENUM } from '@/constants/enum'
import ApprovalFlow from '../../../../components/ApprovalFlow'
import { AppState } from '@/store/types'
import { WorkspaceMemberModel } from '@/services/apis/user/model'
import MyTable from '@/components/Table'
import ShadowView from '@/components/ShadowView'
import cacheUtil, { CACHE_HIDE_SMALL_AMOUNT } from '@/utils/cache'
import ExpandRow from '../../components/ExpandRow'
import Shape from '@/assets/images/shape.png'
import TxSpeed from '@/views/TxSpeed'
import { DestinationTypeEnum } from '@/constants/enum'
import Warning from '@/assets/images/warning.png'
import { resetToStartTime, resetToEndTime, toThousands } from '@/utils/number'
import Header from '../../components/Header'
import { formatUSD } from '@/utils/format'

const { Column } = Table

const TxRecord = memo(() => {
  const { t } = useTranslation()
  // 发送的参数
  const userInfo = useSelector<AppState, WorkspaceMemberModel>(state => {
    return state.user.userInfo as any
  })

  const [queryParam, setQueryParam] = useState<any>({
    minTime: resetToStartTime(new Date() as any) - threeMonth,
    maxTime: resetToEndTime(new Date() as any),
    txStatus: '',
    accountKey: queryString.parse(window.location.search)?.account ?? '',
    coinKey: '',
    createUserId: '',
    network: '',
    condition: '',
    // 一开始获取不到这个值
    hideSmallAmount:
      cacheUtil.get(`${CACHE_HIDE_SMALL_AMOUNT}${userInfo?.userKey}`) !== '0' ?? true,
  })

  useEffect(() => {
    setQueryParam({
      ...queryParam,
      hideSmallAmount:
        cacheUtil.get(`${CACHE_HIDE_SMALL_AMOUNT}${userInfo?.userKey}`) !== '0' ?? true,
    })
  }, [userInfo])

  // 绑定的参数
  const [conditon, setConditon] = useState<TxConditionModel>({
    accountList: [],
    coinKey: [],
    networkList: [],
    statusList: [],
    userList: [],
  })
  const [tableLoading, setTableLoading] = useState(false)
  const [listPage, setListPage] = useState<PageModel<TxRecordsModel>>(
    {} as PageModel<TxRecordsModel>
  )
  // 获取select下拉框的数据
  async function getConditionData() {
    const res = await TxRecordApi.getCondition()
    if (res.success) {
      setConditon(res.data)
    }
  }
  // 获取表格数据
  async function getRecordsList(page = 1) {
    setTableLoading(true)
    const res = await TxRecordApi.searchTxRecords({ pageNumber: page, queryParam: queryParam })
    if (res.success) {
      setListPage(res.data)
    }
    setTableLoading(false)
  }
  const [isMinScreenWidth, setIsMinScreenWidth] = useState(false)

  function getscreenWidth() {
    const screenWidth = window.innerWidth

    if (screenWidth <= MIN_SCREEN_WIDTH) {
      setIsMinScreenWidth(true)
    }
  }
  useEffect(() => {
    getRecordsList()
    getConditionData()
    getscreenWidth()
  }, [])

  useEffect(() => {
    getRecordsList()
  }, [queryParam])

  // 选择框数据
  const statusList = [...[{ key: '', desc: t('record.allStatus') }], ...conditon.statusList]
  const accountList = [...[{ key: '', desc: t('record.allAccout') }], ...conditon.accountList]
  const networkList = [...[{ key: '', desc: t('record.allNetwork') }], ...conditon.networkList]
  const coinKey = [...[{ key: '', desc: t('record.allCoin') }], ...conditon.coinKey]
  const userList = [...[{ key: '', desc: t('record.allUser') }], ...conditon.userList]

  // 表单数据
  function toEllips(text: string) {
    if (!text || text?.length < 17) return text
    return `${text.substring(0, 6)}......${text.substring(text.length - 6, text.length)}`
  }
  function amlFn(v: any) {
    return v.isAml === 1
  }
  // 动态获取class类
  function txStatusColorClass(value: TxStatusEnum) {
    const colorMap = {
      [TxStatusEnum.CANCEL]: styles.normal,
      [TxStatusEnum.NEW]: styles.waiting,
      [TxStatusEnum.BORADCAST]: styles.waiting,
      [TxStatusEnum.CONFIRMING]: styles.waiting,
      [TxStatusEnum.FAILED]: styles.danger,
      [TxStatusEnum.REFUSE]: styles.danger,
      [TxStatusEnum.SUCCESS]: styles.success,
      [TxStatusEnum.SIGNIMG]: styles.waiting,
    }
    return colorMap[value]
  }
  // 渲染表格
  const renderFromCol = (_: any, record: TxRecordsModel) => {
    const sourceName = !record.sourceName ? toEllips(record.sourceAddress) : record.sourceName

    const showAmlTag = record.sourceAddressList.some(amlFn)

    const showWarningTag = record.sourceAddressList.some(i => i.isPhishing === 1)
    return (
      <div>
        {sourceName}
        <div style={{ display: 'flex' }}>
          {showAmlTag && <div className={styles.amlTag}>AML</div>}
          {showWarningTag && (
            <img
              src={Warning}
              alt=""
              style={{ width: '18px', height: '18px', marginLeft: '8px' }}
            ></img>
          )}
        </div>
      </div>
    )
  }
  const renderToCol = (_: any, record: TxRecordsModel) => {
    const destinationName = !record.realDestinationName
      ? toEllips(record.destinationAddress)
      : record.realDestinationName
    const showWarningTag = record.destinationAddressList.some(i => i.isPhishing === 1)
    return (
      <div className={styles.destContainer}>
        <div className={styles.text}>
          {destinationName}
          {showWarningTag && (
            <img
              src={Warning}
              alt=""
              style={{ width: '18px', height: '18px', marginLeft: '8px' }}
            ></img>
          )}
        </div>

        {(record.realDestinationType === 'VAULT_ACCOUNT' ||
          record.realDestinationType === 'INTERNAL_WALLET') && (
          <div className={styles.tag}>
            {record.realDestinationType === 'VAULT_ACCOUNT' && t('record.vaultAccount')}
            {record.realDestinationType === 'INTERNAL_WALLET' && t('record.internalWallet')}
          </div>
        )}
      </div>
    )
  }
  const renderAmount = (_: any, record: TxRecordsModel) => {
    return (
      <div>
        <div>{toThousands(record.amount)}</div>
        <span style={{ color: '#888e8e' }}>≈{formatUSD(record.amountToUsd)}USD</span>
      </div>
    )
  }
  const renderCoin = (_: any, record: TxRecordsModel) => {
    return (
      <CoinImgName
        coinLogoUrl={record.coinLogoUrl}
        networkLogoUrl={record.networkLogo}
        coinName={record.coinName}
        coinFullName={record.coinFullName}
      ></CoinImgName>
    )
  }
  const renderState = (_: any, record: TxRecordsModel) => {
    return (
      <div className={styles.stateContainer}>
        <div
          className={classnames(styles.status_dot, txStatusColorClass(record.transactionStatus))}
        ></div>
        <div>{record.transactionStatusDesc}</div>
      </div>
    )
  }

  // 渲染审批流
  const renderAppFlow = (_: any, record: TxRecordsModel) => {
    return (
      <div>
        {record.auditRecordDto && (
          <ApprovalFlow
            flow={record.auditRecordDto}
            isCancel={record.transactionStatus === 'CANCELLED'}
          />
        )}
      </div>
    )
  }
  function canSpeed(row: any) {
    return (
      row.transactionStatus === TxStatusEnum.BORADCAST &&
      row.sourceType === TX_ACCOUNT_TYPE_ENUM.VAULT &&
      row.canAccelerate
    )
  }
  function canCancel(row: any) {
    return row.transactionStatus === TxStatusEnum.NEW
  }
  const [openSpeed, setOpenSpeed] = useState(false)
  interface outputItem {
    address: string
    value: string
  }
  interface TxRecord {
    coinKey: string
    walletKey: string
    destinationAddress: string
    destinationId: string
    sourceId: string
    sourceAddress: string
    isRbf: boolean
    amount: string
    destinationType: DestinationTypeEnum
    txHash: string
    coinImplTag: string
    transactionType: number
    outputs: outputItem[]
  }
  const [txRecord, setTxRecord] = useState({} as TxRecord)

  function toSpeed(row: TxRecordsModel) {
    const outputs = row.destinationAddressList.map((item: AddressItemModel) => ({
      address: item.address,
      value: item.value,
    }))

    setTxRecord({
      coinKey: row.coinKey,
      walletKey: row.sourceId,
      destinationAddress: row.destinationAddress,
      sourceId: row.sourceId,
      sourceAddress: row.sourceAddress,
      txHash: row.txHash,
      isRbf: row.isRbf,
      amount: row.amount,
      destinationType: row.destinationType,
      destinationId: row.destinationId,
      coinImplTag: row.coinImplTag,
      transactionType: row.transactionType,
      outputs: outputs,
    })
    setOpenSpeed(true)
  }
  function refreshCurrentPageRecords() {
    getRecordsList(page)
  }
  async function cancelTx(row: any) {
    const res = await TxRecordApi.cancelTx(row.txKey)
    if (res.success) {
      message.success(t('record.cancelTxSuccess'))
      refreshCurrentPageRecords()
    }
  }
  // 加速模块
  const renderSpeed = (_: any, record: TxRecordsModel) => {
    return (
      <div style={{ display: 'flex' }}>
        {canSpeed(record) && (
          <div
            style={{ color: '#12b89a', cursor: 'pointer', fontWeight: 'bold' }}
            onClick={() => toSpeed(record)}
          >
            <span style={{ marginRight: '5px', fontWeight: '700' }}>{t('common.speedUp')}</span>
          </div>
        )}
        {canCancel(record) && (
          <div
            style={{ color: '#12b89a', cursor: 'pointer', fontWeight: 'bold' }}
            onClick={() => cancelTx(record)}
          >
            <span style={{ marginRight: '5px', fontWeight: '700' }}>{t('common.cancel')}</span>
          </div>
        )}
      </div>
    )
  }
  // 渲染展开详情
  const renderExpand = (record: TxRecordsModel) => {
    return <ExpandRow records={record} />
  }
  // 格式化表格时间
  function timeFormat(value: number) {
    return `${dayjs(value).format('YYYY-MM-DD HH:mm:ss')}`
  }
  const [page, setPage] = useState(1)
  function changePage(page: number) {
    setPage(page)
    getRecordsList(page)
  }

  const [accountName, setAccountName] = useState(
    queryString.parse(window.location.search)?.accountName
  )
  function getAccountName(accountKey: string) {
    const account = accountList.filter(item => item.key === accountKey)

    if (account.length > 0) {
      setAccountName(accountKey)
    } else {
      setConditon({
        ...conditon,
        accountList: [
          ...conditon.accountList,
          {
            desc: queryString.parse(window.location.search)?.accountName as string,
            key: accountKey,
            addition: '',
          },
        ],
      })
      setAccountName(accountKey)
    }
  }

  useEffect(() => {
    getAccountName(queryParam.accountKey)
  }, [conditon.userList])

  return (
    <div className={styles.container}>
      <Header
        type="Tx"
        queryParam={queryParam}
        setQueryParam={setQueryParam}
        tableLoading={tableLoading}
        accountName={accountName as any}
        setAccountName={setAccountName}
        condition={{
          statusList,
          accountList,
          networkList,
          coinKey,
          userList,
        }}
      />
      {/* table表格区域 */}
      {listPage?.totalElements > 50 && <ShadowView style={{ bottom: 60 }} />}
      <MyTable
        dataSource={listPage?.content}
        loading={tableLoading}
        pagination={{
          pageSize: listPage.pageSize,
          total: listPage?.totalElements,
          showSizeChanger: false,
          onChange: changePage,
          hideOnSinglePage: true,
        }}
        bottomY={70}
        rowKey={record => record.txKey}
        expandable={{
          expandedRowRender: renderExpand,
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <div onClick={e => onExpand(record, e)} className={styles.expand}>
                <div style={{ marginRight: '5px' }}>{t('record.detail')}</div>
                <div>
                  <img
                    src={Shape}
                    alt=""
                    style={{ width: '10px', height: 'auto', transform: 'rotate(180deg)' }}
                  />
                </div>
              </div>
            ) : (
              <div onClick={e => onExpand(record, e)} className={styles.expand}>
                <div style={{ marginRight: '5px' }}>{t('record.detail')}</div>
                <div>
                  <img src={Shape} alt="" style={{ width: '10px', height: 'auto' }} />
                </div>
              </div>
            ),
          expandIconColumnIndex: 9,
          columnWidth: 100,
        }}
      >
        <Column title={t('record.time')} dataIndex="txTime" render={timeFormat} width={110} />
        <Column title={t('record.from')} key="txTime" render={renderFromCol} />
        <Column title={t('record.to')} render={renderToCol} width={220} />
        <Column title={t('record.amount')} render={renderAmount} width={200} />
        <Column title={t('record.coin')} render={renderCoin} width={isMinScreenWidth ? 150 : 200} />
        <Column title={t('record.state')} render={renderState} width={100} />
        {isMinScreenWidth ? (
          <Column title={t('record.createUser')} dataIndex="createUserName" width={70} />
        ) : (
          <Column title={t('record.createUser')} dataIndex="createUserName" />
        )}
        <Column title={t('common.approval')} render={renderAppFlow} width={140} />
        <Column render={renderSpeed} width={70} />
      </MyTable>
      <TxSpeed
        open={openSpeed}
        onClose={() => setOpenSpeed(false)}
        txRecord={txRecord}
        refresh={refreshCurrentPageRecords}
      ></TxSpeed>
    </div>
  )
})

export default TxRecord
